module.exports = __webpack_public_path__ + "static/img/02ko.e61c3ef.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/placestogo/06/02ko.jpg
// module id = ojIt
// module chunks = 0